import { render, staticRenderFns } from "./InvoiceSearchItem.vue?vue&type=template&id=52ef06d0"
import script from "./InvoiceSearchItem.vue?vue&type=script&lang=js"
export * from "./InvoiceSearchItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports